'use es6';

let _ = t => t,
    _t;

import { OBSIDIAN } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
const HubSubtitle = styled.div.withConfig({
  displayName: "HubSubtitle",
  componentId: "sc-21snvc-0"
})(["color:", ";font-size:14px;line-height:24px;text-align:center;margin-bottom:20px;"], OBSIDIAN);
export const Mon569HubSubtitle = styled.div.withConfig({
  displayName: "HubSubtitle__Mon569HubSubtitle",
  componentId: "sc-21snvc-1"
})(["color:", ";font-size:14px;line-height:24px;text-align:left;margin-bottom:20px;", ";"], OBSIDIAN, breakpoint.cs(_t || (_t = _`
    text-align: center;
  `)));
export default HubSubtitle;